import axios from "axios";

// If the configured backend URL points to a different host than the one
// currently serving the frontend, prefer the current origin. This avoids
// cross-origin redirects (e.g. Cloudflare 308 from xega.com.mx → www.xega.com.mx)
// that would otherwise drop the POST body / cookies during login.
function resolveBackendUrl() {
  const configured = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return configured;
  try {
    if (!configured) return window.location.origin;
    const cfgHost = new URL(configured).host;
    if (cfgHost !== window.location.host) return window.location.origin;
    return configured;
  } catch (_e) {
    return window.location.origin;
  }
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("xega_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("xega_token");
  }
}

const saved = localStorage.getItem("xega_token");
if (saved) setAuthToken(saved);
